import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";

export const RoundedBlockWrapper = styled.div.attrs({
    id: "roundedBlockWrapper",
})`
    margin: 0 auto;
    display: flex;
`;

export const RoundedBlockInnerWrapper = styled.div.attrs(
    ({bgColor}) => ({
        id: "roundedBlockInnerWrapper",
        bgColor: bgColor ? bgColor : undefined
    })
)`
    padding: 1rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    flex-direction: column;
    margin-top: 40px;
    ${({bgColor}) =>
            bgColor &&
            css`
                background-color: ${({bgColor}) => bgColor};
            `}
    & {
        ${media.greaterThan(breakpoints.ipadPlus)`	        
           border-radius: ${({theme}) => theme.border.radius};	    
           padding: 48px 80px 64px 80px;
           gap: 4rem;
           margin-top: ${({theme}) => theme?.block?.gap ? theme?.block?.gap : "0"};
    `}
`;

export const RoundedBlockItemWrapper = styled.div.attrs({

})`
    display: flex;
    flex: 1;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem
`;


export const RoundedBlockItem = styled.div.attrs(
    ({bgColor}) => ({
        bgColor: bgColor ? bgColor : undefined
    })
)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;   
`;
export const RoundedBlockItemImage = styled.div.attrs(
    ({bgColor}) => ({
        bgColor: bgColor ? bgColor : undefined
    })
)`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    height: 160px;
    width: 160px;
    overflow: hidden;
    ${({bgColor}) =>
            bgColor &&
            css`
                background-color: ${({bgColor}) => bgColor};
            `}
    & {
        ${media.greaterThan(breakpoints.ipadPlus)`		    
           height: 200px;
           width: 200px;
    `}
`;

